<ion-button *ngIf="isNotEngaged" expand="block" (click)="engage()">
  {{ 'Mobile.EngageToInstruction' | translate }}
</ion-button>
